<template>
  <form class="container-fluid">
    <div class="lux_payment">
      <!-- Select Payment Type -->
      <div class="row ">
        <div class="col-md-6">
          <label style="color:#0892D0;" for="payment_type"
            >Select Payment Type</label
          >
          <select
            name="payment_type"
            id="payment_type"
            placeholder="Select a Payment Type"
            v-model="luxPayment.paymentType"
            class="form-control form-control-lg"
          >
            <option value="" disabled selected hidden
              >Select a Payment Type</option
            >
            <option value="OS">Outright Sale (OS)</option>
            <option value="LO">Lease to Own (LO)</option>
            <option value="ES">ENERGY AS A SERVICE (ES)</option>
          </select>
        </div>
        <div class="col-md-6">
          <label style="color:#0892D0;" for="CLoad">Enter CLoad Value</label>
          <input
            type="number"
            name="Cload"
            id="Cload"
            placeholder="Contractual Load"
            v-model="luxPayment.cLoadValue"
            class="form-control form-control-lg"
          />
        </div>
      </div>
      <!-- Enter Device version and Device CID -->
      <div class="row">
        <div class="col-md-6">
          <label style="color:#0892D0;" for="device_version"
            >Select Device Version</label
          >
          <select
            name="device_version"
            id="device_version"
            v-model="luxPayment.deviceVersion"
            class="form-control form-control-lg"
          >
            <option value="" disabled selected hidden
              >Select a Device version</option
            >
            <option value="v3">System Version 3</option>
            <option value="v5">System Version 5</option>
            <option value="v6">System Version 6</option>
            <option value="v7">System Version 7</option>
          </select>
        </div>
        <div class="col-md-6">
          <label style="color:#0892D0;" for="CID">Device CID</label>
          <input
            type="number"
            name="CID"
            id="CID"
            placeholder="CID"
            v-model="luxPayment.CID"
            class="form-control form-control-lg"
          />
        </div>
      </div>
      <!-- Select Charge Cycle and Expected Charge Cycle -->
      <div class="row">
        <div class="col-md-6">
          <label style="color:#0892D0;" for="charge_cycle">Charge Cycle</label>
          <input
            type="number"
            name="Charge Cycle"
            id="charge_cycle"
            placeholder="Charge Cycle"
            v-model="luxPayment.Charge"
            class="form-control"
          />
        </div>
        <div class="col-md-6">
          <label style="color:#0892D0;" for="E_charge_cycle"
            >Exptd. Charge Cycle</label
          >
          <input
            type="number"
            name="E_charge_cycle"
            id="E_charge_cycle"
            placeholder="Expected Charge Cycle"
            v-model="luxPayment.ExptdCharge"
            class="form-control form-control-lg"
          />
        </div>
      </div>
      <!-- Button -->
      <div class="container-fluid">
        <div class="button_style">
          <button
            type="submit"
            class="btn btn-outline-primary btn-lg"
            @click="back"
          >
            Back
          </button>
          <button type="button" class="btn btn-primary btn-lg" @click="submit">
            Onboard
          </button>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import { isEmpty } from "element-ui/src/utils/util";
export default {
  name: "LuxPayment",
  components: {},
  data() {
    return {
      StoreLuxOnboardingStatus: this.$store.state.luxOnboardingStatus,
      StateLuxPaymentStatus: this.$store.state.luxPaymentStatus,
      GetLuxOnboardingStates: this.$store.getters.getLuxOnboardingStates,
      luxPayment: {
        paymentType: "",
        cLoadValue: "",
        deviceVersion: "",
        CID: "",
        Charge: "",
        ExptdCharge: ""
      },
      validateError: false
    };
  },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
      message: "Success Msg!"
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
      message: "Error Msg!"
    }
  },
  methods: {
    validateReg() {
      let errors = [];
      for (let [field, value] of Object.entries(this.luxPayment)) {
        value = value + "";
        if (value !== null && value !== Number.isInteger(value)) {
          value = value.trim();
        }
        switch (field) {
          case "paymentType":
            if (value === "" || value === NaN || isEmpty(value)) {
              errors[field] = "paymentType cannot be empty.";
            }
            break;
          case "cLoadValue":
            if (value === "" || value === NaN || isEmpty(value)) {
              errors[field] = "cLoadValue cannot be empty.";
            }
            break;
          case "deviceVersion":
            if (value === "" || value === NaN || isEmpty(value)) {
              errors[field] = "deviceVersion cannot be empty.";
            }
            break;
          case "CID":
            if (value === "" || value === NaN || isEmpty(value)) {
              errors[field] = "CID cannot be empty.";
            }
            break;
          case "ChgCycle":
            if (value === "" || value === NaN || isEmpty(value)) {
              errors[field] = "Charge cannot be empty.";
            }
            break;
          case "ExptdChgCyl":
            if (value === "" || value === NaN || isEmpty(value)) {
              errors[field] = "ExptdCharge cannot be empty.";
            }
            break;
          default:
            break;
        }
        this.errorsResult = errors;
      }
      var errorLength = Object.keys(this.errorsResult).length;
      if (errorLength > 0) {
        this.errorMessage = "Fill All FIelds!!!";
        this.displayError = true;
        this.validateError = true;
        setTimeout(() => {
          this.displayError = false;
        }, 3000);
        var errorMsg = Object.values(this.errorsResult).join("<br>");
        this.showErrorMsg({
          message: errorMsg
        });

        return;
      } else {
        this.validateError = false;
      }
    },
    submit() {
      this.validateReg();
      if (this.validateError === false) {
        let MiscData = {
          CID: this.luxPayment.CID,
          ChgCycle: this.luxPayment.Charge,
          ExptdChgCyl: this.luxPayment.ExptdCharge
        };
        let allParams = {
          deviceId: this.StoreLuxOnboardingStatus.deviceId,
          serialNumbers: this.StoreLuxOnboardingStatus.serialNumbers,
          paymentType: this.luxPayment.paymentType,
          CLoad: this.luxPayment.cLoadValue,
          Version: this.luxPayment.deviceVersion,
          MiscData
        };

        const LuxHTTP = this.$httpUtils.LUXHTTP;
        let url = `/devices`;
        LuxHTTP.post(url, allParams)
          .then(response => {
            this.showSuccessMsg({ message: "Device setup successfully!" });
            window.history.back();
            this.$store.state.luxCount = 1;
          })
          .catch(error => {
            this.showErrorMsg({ message: "Error occured at our end!" });
          });
      } else {
        console.log("Validate data first");
      }
    },
    back() {
      this.$store.state.luxCount = 1;
      this.GetLuxOnboardingStates.serialNumbers = [];
      this.GetLuxOnboardingStates.deviceId = "";
    }
  },
  mounted() {}
};
</script>

<style scoped>
.button_style {
  display: grid;
  grid-template-columns: auto auto;
  column-gap: 80%;
  font-family: sans-serif;
  width: 100%;
  margin: auto;
  padding: 24px 0;
}
.lux_payment {
  font-family: sans-serif;
}
.lux_payment label {
  font-size: 12px;
  font-weight: 500;
  margin-top: 12px;
}
.lux_payment select {
  background: #f1f1f1;
  border: none;
  box-shadow: none;
  outline: none;
  height: 55px !important;
  border-radius: 3px;
  padding-left: 26px;
  color: #222;
}
.lux_payment input {
  background: #f1f1f1;
  border: none;
  box-shadow: none;
  outline: none;
  height: 55px !important;
  border-radius: 3px;
  padding-left: 26px;
  color: #222;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/luxOnboarding/LuxPayment.vue